import API from "@/api/lib/api";

export const getAllSmartQrCode = async (restaurant_id, page = 1, per_page = 10, search_term = "", status = "") => {
  try {
    let query = `?page=${page}&per_page=${per_page}`;
    if (search_term) query += `&search_term=${encodeURIComponent(search_term)}`;
    if (status && status !== 'all') query += `&status=${encodeURIComponent(status)}`;
    
    const response = await API.get(`online-order/ordering/restaurant/${restaurant_id}/smart-qr-codes${query}`);
    return response.data;
  } catch (error) {
    return (
      error.response?.data || {
        status: "failure",
        message: "Something went wrong.",
      }
    );
  }
};

export const getSingleSmartQrCode = async (item_id) => {
  try {
    const response = await API.get(`online-order/ordering/smart-qr-codes/${item_id}`);
    return response.data;
  } catch (error) {
    return (
      error.response?.data || {
        status: "failure",
        message: "Something went wrong.",
      }
    );
  }
};

export const createSmartQrCode = async (data) => {  
  try {
    const response = await API.post(`online-order/ordering/smart-qr-codes`, data);
    return response.data;
  } catch (error) {
    console.error("Error creating smart-qr-codes:", error);
    return {
      status: "failure",
      message: error.response?.data.message || "Something went wrong.",
    };
  }
};

export const updateSmartQrCode = async (item_id, data) => {
  try {
    const response = await API.put(`online-order/ordering/smart-qr-codes/${item_id}`, data);
    return response.data;
  } catch (error) {
    return (
      error.response?.data || {
        status: "failure",
        message: "Something went wrong.",
      }
    );
  }
};

export const toggleSmartQrCode = async (id, status) => {
  try {
    // Assuming toggle endpoint is available, otherwise we use standard update
    const response = await API.put(
      `online-order/ordering/smart-qr-codes/${id}/toggle`,
      { status }
    );
    return response.data;
  } catch (error) {    
    return (
      error.response?.data || {
        status: "failure",
        message: "Something went wrong.",
      }
    );
  }
};

export const deleteSmartQrCode = async (item_id) => {
  try {
    const response = await API.delete(`online-order/ordering/smart-qr-codes/${item_id}`);
    return response.data;
  } catch (error) {
    return (
      error.response?.data || {
        status: "failure",
        message: "Something went wrong.",
      }
    );
  }
};
